module.exports = __webpack_public_path__ + "img/img-139.164ae038.png";